<div class="expiry-dialog">
  <div class="expiry-dialog-header flex-start-center">
    <i class="fal fa-file-contract font-gray-55 font-20 pr-3"></i>
    <p class="m-0 font-bold font-14 font-black">{{title}}</p>
    <span *ngIf="!isSubscriptionExpired" class="close-modal ml-auto">
      <i class="fal fa-times" (click)="close(false)"></i>
    </span>
  </div>

  <div class="expiry-dialog-body flex-column flex-wrap flex-start-start">
    <p class="mt-2">{{description}}</p>
    <div class="expiry-field ui-g-12 p-0">
      <app-input [id]="'exp-name'" placeholder="Name" [value]="contactInfo.name" theme="secondary"
        (appChange)="contactInfo.name" [floatingLabel]="true" [maxLength]="50">
      </app-input>
    </div>
    <div class="expiry-field ui-g-12 p-0">
      <app-input [id]="'exp-name'" placeholder="Preferred contact #" [value]="contactInfo.phone" theme="secondary"
        (appChange)="contactInfo.phone" [floatingLabel]="true" [maxLength]="50">
      </app-input>
    </div>
    <div class="expiry-field ui-g-12 p-0">
      <app-input [id]="'exp-name'" placeholder="Preferred email" [value]="contactInfo.email" theme="secondary"
        (appChange)="contactInfo.email" [floatingLabel]="true" [maxLength]="50">
      </app-input>
    </div>
    <div *ngIf="isSubscriptionExpired" class="expiry-field ui-g-12 p-0 my-0">
      <a (click)="logout()" class="text-primary font-600 pointer">
        Logout
      </a>
    </div>
  </div>

  <div class="expiry-dialog-footer flex-end-center">
    <button *ngIf="isSubscriptionExpired" class="btn btn-white btn-border pointer btn-submit mr-2"
      (click)="submitTrialExtensionRequest()">Request Extension</button>
    <button *ngIf="!isSubscriptionExpired" class="btn btn-white btn-border pointer btn-submit mr-2"
      (click)="close(false)">Cancel</button>
    <button class="btn btn-primary btn-submit" (click)="submitSubscriptionRequest()">
      {{isSubscriptionExpired ? 'Subscribe ' : 'Send'}}
      <i class="fal fa-spinner rotate" *ngIf="processing"></i>
    </button>
  </div>
</div>
